import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../Icon';
import Tooltip from '../Tooltip';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconTool = function IconTool(_ref) {
  var _tooltip$component;

  var active = _ref.active,
      className = _ref.className,
      disabled = _ref.disabled,
      floating = _ref.floating,
      icon = _ref.icon,
      small = _ref.small,
      medium = _ref.medium,
      onClick = _ref.onClick,
      rectangular = _ref.rectangular,
      tooltip = _ref.tooltip;
  var classes = classnames('ptr-IconTool', {
    'is-active': active,
    'is-disabled': disabled,
    'is-floating': floating,
    'is-rectangular': rectangular,
    'is-medium': medium && !small,
    'is-small': small && !medium
  }, className);

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      onClick();
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    tabIndex: disabled ? -1 : 0,
    className: classes,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    "data-tip": tooltip === null || tooltip === void 0 ? void 0 : tooltip.text,
    "data-for": tooltip === null || tooltip === void 0 ? void 0 : tooltip.id,
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: icon
    }), tooltip && !disabled ? /*#__PURE__*/React.createElement(tooltip.component || Tooltip, _objectSpread(_objectSpread({}, (_tooltip$component = tooltip.component) === null || _tooltip$component === void 0 ? void 0 : _tooltip$component.props), {}, {
      id: tooltip.id,
      place: tooltip.position || 'top',
      effect: 'solid',
      delayShow: tooltip.delayShow || 1000
    })) : null]
  });
};

IconTool.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  floating: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  medium: PropTypes.bool,
  onClick: PropTypes.func,
  rectangular: PropTypes.bool,
  small: PropTypes.bool,
  tooltip: PropTypes.object
};
export default IconTool;